/** Pie/donut-chart config, grouped so members are accessed as `PieChartConstants.x`. */
export const PieChartConstants = {
  /** Categorical slice palette matching the Figma "Cost/Unit" donut (red/orange/green/teal), then purples. */
  palette: [
    "#F44336",
    "#FF8A00",
    "#30CD89",
    "#1B7A3E",
    "#17A2B8",
    "#7B61FF",
    "#B961FF",
    "#4A209C",
  ],
  doughnutCutout: "55%",
  sliceBorderWidth: 2,
} as const;
